import { defineStore } from 'pinia';
import { GET_REGISTRANT_MY_TAB_INFO, REMOVE_ITEMS_BY_ID } from '~/types/actions';
import {
  SET_REGISTRANT_MY_GIFT_RESPONSE,
  SET_ERROR_VISIBLE,
  SET_REGISTRANT_MY_GIFT_LOADER,
  SET_STORE_ERROR_STATE,
  SET_UPDATED_PRODUCTS,
  SET_REMOVE_ITEM_API_ERROR_RESPONSE,
  SET_REGISTRANT_MY_GIFT_API_ERROR_RESPONSE,
  SET_REGISTRANT_MY_GIFT_API_ERROR_DESCRIPTION,
  SET_REGISTRANT_MY_GIFT_API_ERROR_STATUS_CODE,
} from '~/types/mutations';
import { SoftSignInValidation } from '~/utils/SoftSignInValidation.js';
import { httpUpdateAPIHeaders } from '~/utils/APIUtil';
import { generateLogin365FingerPrint } from '~/utils/PersistentLoginUtil';
import $http from '@vue-util/http';
import { useEnvPropsStore } from './envProps';

const REGISTRANT_MY_GIFT_ENDPOINT = '/regsvc/registry/api/v1/registry/getRegistryInfo';
const DELETE_ITEM_REGISTRY_ENDPOINT = '/regsvc/registry/api/v1/preference/deletePreference';

export const useRegistrantMyGiftTabStore = defineStore('registrantMyGiftTab', {
  state: () => ({
    registrantMyGiftResponse: {},
    errorVisibility: false,
    registrantMyGiftLoader: false,
    errorState: false,
    removeItemApiErrorResponse: null,
    registrantMyGiftApiErrorResponse: null,
    registrantMyGiftApiErrorDescription: '',
    statusCode: false,
  }),
  actions: {
    [SET_REGISTRANT_MY_GIFT_RESPONSE](registrantMyGiftResponse) {
      this.registrantMyGiftResponse = registrantMyGiftResponse;
    },
    [SET_UPDATED_PRODUCTS](updatedProducts) {
      this.registrantMyGiftResponse.registryItem = updatedProducts;
    },
    [SET_ERROR_VISIBLE](payload) {
      this.errorVisibility = payload;
    },
    [SET_REGISTRANT_MY_GIFT_LOADER](payload) {
      this.registrantMyGiftLoader = payload;
    },
    [SET_STORE_ERROR_STATE](payload) {
      this.errorState = payload;
    },
    [SET_REMOVE_ITEM_API_ERROR_RESPONSE](payload) {
      this.removeItemApiErrorResponse = payload;
    },
    [SET_REGISTRANT_MY_GIFT_API_ERROR_RESPONSE](error) {
      this.registrantMyGiftApiErrorResponse = error;
    },
    [SET_REGISTRANT_MY_GIFT_API_ERROR_DESCRIPTION](registrantMyGiftApiErrorDescription) {
      this.registrantMyGiftApiErrorDescription = registrantMyGiftApiErrorDescription;
    },
    [SET_REGISTRANT_MY_GIFT_API_ERROR_STATUS_CODE](error) {
      this.statusCode = error;
    },
    async [GET_REGISTRANT_MY_TAB_INFO](payload) {
      const envPropsStore = useEnvPropsStore();

      this[SET_STORE_ERROR_STATE](false);
      this[SET_REGISTRANT_MY_GIFT_LOADER](true);
      const httpSource = $http.CancelToken.source();
      const timer = setTimeout(() => {
        this[SET_REGISTRANT_MY_GIFT_RESPONSE]({});
        this[SET_STORE_ERROR_STATE](true);
        this[SET_REGISTRANT_MY_GIFT_LOADER](false);
        httpSource.cancel();
      }, envPropsStore.envProps?.apiTimeout || 0);
      try {
        const login365FingerPrint = await generateLogin365FingerPrint();
        const response = await $http.post(`${REGISTRANT_MY_GIFT_ENDPOINT}`, payload, {
          headers: httpUpdateAPIHeaders(payload, login365FingerPrint),
          cancelToken: httpSource.token,
        });
        clearTimeout(timer);
        const isError = response?.data?.errors || response?.data?.error;
        if (isError) {
          this[SET_REGISTRANT_MY_GIFT_RESPONSE]({});
          this[SET_STORE_ERROR_STATE](true);
          this[SET_REGISTRANT_MY_GIFT_API_ERROR_RESPONSE](isError?.[0]);
          this[SET_REGISTRANT_MY_GIFT_API_ERROR_DESCRIPTION](isError?.[0]?.description);
        } else {
          this[SET_REGISTRANT_MY_GIFT_RESPONSE](response.data.registryInfo);
        }
      } catch (error) {
        if (error.response?.data?.status === 401) {
          this[SET_REGISTRANT_MY_GIFT_API_ERROR_STATUS_CODE](true);
        }
        SoftSignInValidation(error);
        this[SET_REGISTRANT_MY_GIFT_RESPONSE]({});
        this[SET_REGISTRANT_MY_GIFT_API_ERROR_RESPONSE](error?.response?.data?.errors?.[0] || error?.response?.data?.error?.[0]);
        this[SET_REGISTRANT_MY_GIFT_API_ERROR_DESCRIPTION]('');
        clearTimeout(timer);
      } finally {
        this[SET_REGISTRANT_MY_GIFT_LOADER](false);
      }
    },
    async [REMOVE_ITEMS_BY_ID](payload) {
      this[SET_ERROR_VISIBLE](false);
      try {
        const login365FingerPrint = await generateLogin365FingerPrint();
        await $http.delete(`${DELETE_ITEM_REGISTRY_ENDPOINT}`, {
          headers: httpUpdateAPIHeaders(payload, login365FingerPrint),
          data: payload,
        });
      } catch (error) {
        SoftSignInValidation(error);
        this[SET_REMOVE_ITEM_API_ERROR_RESPONSE](error?.response?.data?.errors?.[0] || error?.response?.data?.error?.[0]);
        this[SET_ERROR_VISIBLE](true);
      }
    },
  },
});
